export default "__VITE_ASSET__II96Xxvy__"